import { setActiveCategoryRaw } from '../../action/raw';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = null;

export default createReducer(
  [forAction(setActiveCategoryRaw, identityPayload)],
  initialState,
);
